/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoUpdateContainerInput = {
    clientMutationId?: string | null;
    slug: string;
    profileImageSlug?: string | null;
    containerNumber: string;
    voyageSlug: string;
    containerType: string;
    containerSize?: string | null;
    procedure?: string | null;
    atb?: string | null;
    bookingNumber?: string | null;
    turninLocationSlug?: string | null;
    pickupLocationSlug?: string | null;
    pickupReference?: string | null;
    turninReference?: string | null;
    pickupComment?: string | null;
    billOfLadingNumber?: string | null;
    terminalDate?: string | null;
    dischargeDate?: string | null;
    latestPickupDate?: string | null;
    pickupDate?: string | null;
    latestTurninDate?: string | null;
    thcPaidDate?: string | null;
    linkedContacts: Array<LinkedContactInput>;
    shippingLineSlug: string;
};
export type LinkedContactInput = {
    role: string;
    contactSlug: string;
};
export type ContainerPickSentMutationVariables = {
    input: infoUpdateContainerInput;
};
export type ContainerPickSentMutationResponse = {
    readonly infoUpdateContainer: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ContainerPickSentMutation = {
    readonly response: ContainerPickSentMutationResponse;
    readonly variables: ContainerPickSentMutationVariables;
};



/*
mutation ContainerPickSentMutation(
  $input: infoUpdateContainerInput!
) {
  infoUpdateContainer(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoUpdateContainerPayload",
    "kind": "LinkedField",
    "name": "infoUpdateContainer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContainerPickSentMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContainerPickSentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "62330fc235bdbd7879b2887dfa667abb",
    "id": null,
    "metadata": {},
    "name": "ContainerPickSentMutation",
    "operationKind": "mutation",
    "text": "mutation ContainerPickSentMutation(\n  $input: infoUpdateContainerInput!\n) {\n  infoUpdateContainer(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '600485f5e2a785ccc410bedb1656fea0';
export default node;
